module.exports = __webpack_public_path__ + "static/media/blog-3.d6d343c0.svg";